/* eslint-disable camelcase */
import jwtDecode from 'jwt-decode';

export default accessToken => {
  const tokenData = jwtDecode(accessToken);

  const normalizedData = {
    _id: tokenData.userId,
    fullName: tokenData.fullName,
    user_id: tokenData.userId,
    username: tokenData.fullName,
    email: tokenData.name,
    displayName: tokenData.fullName,
    accountId: tokenData.accountId,
    userRoles: tokenData.userRoles,

    requester: tokenData.requester,
  };

  window.localStorage.setItem(
    'guesty_user_data',
    JSON.stringify(normalizedData)
  );
};
